// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import PackageManager from "../../components/dashboard/PackageManager";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <PackageManager />
    </DashboardLayout>
  );
}
